import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface LoadingIndicatorProps {
  isLoading: boolean;
  loadingText?: string;
  loadedText?: string;
  className?: string;
}

export function LoadingIndicator({
  isLoading,
  loadingText = "Loading...",
  loadedText = "Loaded",
  className,
}: LoadingIndicatorProps) {
  return (
    <span className={cn("text-xs text-muted-foreground inline-flex items-center gap-1", className)}>
      {isLoading ? (
        <>
          <Loader2 className="h-3 w-3 animate-spin" />
          {loadingText}
        </>
      ) : (
        loadedText
      )}
    </span>
  );
}